import { render, staticRenderFns } from "./Tekshiruv.vue?vue&type=template&id=6eac7d32"
import script from "./Tekshiruv.vue?vue&type=script&lang=js"
export * from "./Tekshiruv.vue?vue&type=script&lang=js"
import style0 from "./Tekshiruv.vue?vue&type=style&index=0&id=6eac7d32&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports